import { FormikContext, getIn } from 'formik';

export function resolveProps<T extends { name: string }>(
  props: T,
  formik: FormikContext<any>
) {
  const error = getIn(formik.errors, props.name);
  const value = getIn(formik.values, props.name);
  const touched = getIn(formik.touched, props.name);
  const onBlur = formik.handleBlur;
  const valid = !error;
  const formikProps = {
    checked: value,
    error,
    errorMessage: typeof error === 'string' ? error : '',
    onBlur,
    toggled: value,
    touched,
    valid,
    value
  };
  return Object.assign({}, formikProps, props);
}

export function shouldUpdate<T extends { name: string }>(
  oldProps: T & { formik: FormikContext<any> },
  newProps: T & { formik: FormikContext<any> }
) {
  const {
    value: oldValue,
    checked: oldChecked,
    toggled: oldToggled,
    error: oldError,
    touched: oldTouched
  } = resolveProps<T>(oldProps, oldProps.formik);
  const {
    value: newValue,
    checked: newChecked,
    toggled: newToggled,
    error: newError,
    touched: newTouched
  } = resolveProps<T>(newProps, newProps.formik);

  if (
    oldValue !== newValue ||
    oldChecked !== newChecked ||
    oldToggled !== newToggled ||
    oldError !== newError ||
    oldTouched !== newTouched ||
    Object.keys(oldProps).length !== Object.keys(newProps).length ||
    oldProps.formik.isSubmitting !== newProps.formik.isSubmitting
  ) {
    return true;
  }

  return false;
}
